import { Skeleton } from 'antd'
import { rest } from 'lodash'
import { Suspense } from 'react'
import { Switch, Route } from 'react-router-dom'

import Header from '../../app/Header'

interface IPropsTopMenuLayout {
  routes: Routes
}

const TopMenuLayout: React.FC<IPropsTopMenuLayout> = ({ routes }) => {
  return (
    <div className="layout">
      <Header></Header>
      <Suspense fallback={<Skeleton active></Skeleton>}>
        <Switch>
          {routes.map(route => (
            <Route
              key={route.path}
              path={route.path}
              render={props => (
                <route.component {...props} {...rest} route={route} routes={route.routes} />
              )}
            />
          ))}
        </Switch>
      </Suspense>
    </div>
  )
}

export default TopMenuLayout
